import { RootState } from '@/store'
import { getUsers } from '@/store/selectors'
import { mapToUser } from '@/utilities/UserUtilities'

export const getOrganizationAdmins = (state: RootState) => {
  const adminUserIds = state.organizationSettingsPage.users
  if (adminUserIds) {
    const users = getUsers(state)
    return adminUserIds.map(user => {
      return mapToUser(users.byId[user])
    })
  }
}

export const getSearchedUsersNotAlreadyAdmins = (state: RootState) => {
  if (state.organizationSettingsPage && state.organizationSettingsPage.searchedUsers) {
    const users = getUsers(state)
    const filteredSearchedUsers = state.organizationSettingsPage.searchedUsers.filter(
      user =>
        !getOrganizationAdmins(state)
          ?.map(u => u.id)
          .includes(user)
    )
    return filteredSearchedUsers.map(user => {
      return mapToUser(users.byId[user])
    })
  } else {
    return []
  }
}
